module.exports = __webpack_public_path__ + "img/int7_ros_rel_01.fc133e06.jpg";